import { render } from "./AppLogo.vue?vue&type=template&id=f2c4992e&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=f2c4992e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c4992e"]])

export default __exports__